class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    // Listen for cart updates to reload thumbnails
    document.addEventListener('cart:updated', () => this.loadPersonalizedThumbnails());
    document.addEventListener('ajaxProduct:added', () => this.loadPersonalizedThumbnails());

    // Also run on initial page load after a short delay
    setTimeout(() => this.loadPersonalizedThumbnails(), 100);
  }

  // Load personalized thumbnails from localStorage
  loadPersonalizedThumbnails() {
    setTimeout(() => {
      // Look in both mini-cart container and the form with id="cart"
      const personalizedImages = document.querySelectorAll('#mini-cart img[data-order-id], #cart img[data-order-id], .mini-cart img[data-order-id]');

      console.log('[MiniCart] Loading thumbnails for', personalizedImages.length, 'personalized images');

      personalizedImages.forEach(img => {
        const orderId = img.dataset.orderId;
        if (!orderId) return;

        // Check localStorage for instant thumbnail
        const thumbnailKey = `thumbnail_${orderId}`;
        const storedThumbnail = localStorage.getItem(thumbnailKey);

        console.log('[MiniCart] Thumbnail check for', orderId, ':', storedThumbnail ? 'found' : 'not found');

        // Apply if non-data-URL src is current (avoid clobbering an already-applied thumb).
        const applyStored = () => {
          if (storedThumbnail && !img.src.startsWith('data:')) {
            img.src = storedThumbnail;
            img.onerror = null;
            console.log('[MiniCart] Loaded thumbnail for', orderId);
          }
        };
        const applyBackendFallback = () => {
          if (img.dataset.fallbackSrc) {
            const backendUrl = img.dataset.backendThumbnail;
            if (backendUrl) {
              img.src = backendUrl;
              console.log('[MiniCart] Trying backend thumbnail for', orderId);
            }
          }
        };

        if (storedThumbnail) {
          // Self-heal: if a customer hit the pre-fix black-thumbnail bug,
          // their localStorage holds a uniform-colour data URL. Validate
          // before applying — purge if invalid so the next visit gets the
          // backend fallback / placeholder.
          if (typeof window.skylitValidateThumbnail === 'function') {
            window.skylitValidateThumbnail(storedThumbnail).then((ok) => {
              if (!ok) {
                try { localStorage.removeItem(thumbnailKey); } catch (e) {}
                console.warn('[MiniCart] Purged invalid localStorage thumbnail for', orderId);
                applyBackendFallback();
                return;
              }
              applyStored();
            });
          } else {
            applyStored();
          }
        } else {
          applyBackendFallback();
        }
      });
    }, 50);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));

          // Load thumbnails after content is inserted
          this.loadPersonalizedThumbnails();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();

    // Load personalized thumbnails after content is rendered
    this.loadPersonalizedThumbnails();

    // Dispatch event for other listeners
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
